import { default as ContactAvatar } from '../_internal/components/ContactAvatar';
export default ContactAvatar;